var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer border-top text-center"},[_c('vueMarkdown',{attrs:{"source":this.common.pagefooter,"breaks":true,"typographer":true,"linkify":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }